import { RootState } from '@reducers';

export const selectCarQuoteDetailsRoute = (state: RootState) => state.carQuoteDetailsRouteReducer;
